import { render, staticRenderFns } from "./BSidebarMenu.vue?vue&type=template&id=6c08a78a&scoped=true"
import script from "./BSidebarMenu.vue?vue&type=script&lang=js"
export * from "./BSidebarMenu.vue?vue&type=script&lang=js"
import style0 from "./BSidebarMenu.vue?vue&type=style&index=0&id=6c08a78a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c08a78a",
  null
  
)

export default component.exports